import React from "react";
import { Box, IconButton, MenuItem, Select, Typography } from "@mui/material";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import { colCenter } from "../style/style";
/**
 * Compact pagination bar for mobile card views, mirroring the desktop DataGrid
 * footer: a rows-per-page dropdown, an "X-Y van Z" range label, and prev/next
 * chevron arrows — all in a single rounded bar. Functionally identical to the
 * grid pagination (page navigation + page-size change).
 */
export const CardPagination = ({ count, page, pageSize, onPageChange, onPageSizeChange, pageSizeOptions = [5, 10, 25], }) => {
    const pageCount = Math.max(1, Math.ceil(count / pageSize));
    const from = count === 0 ? 0 : page * pageSize + 1;
    const to = Math.min(count, (page + 1) * pageSize);
    // Always include the current pageSize so the Select never renders blank when
    // the caller's default size isn't part of pageSizeOptions.
    const options = Array.from(new Set([...pageSizeOptions, pageSize])).sort((a, b) => a - b);
    return (React.createElement(Box, { sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 0.5,
            minHeight: 56,
            px: 1,
            py: 1,
            borderRadius: "16px",
            background: (theme) => theme.palette.background.neutral,
            fontSize: "14px",
            color: "#00244D",
        } },
        React.createElement(Box, { sx: Object.assign(Object.assign({}, colCenter), { gap: 0.5 }) },
            React.createElement(Typography, { component: "span", sx: { fontSize: "14px", color: "#00244D", whiteSpace: "nowrap" } }, "Rijen per pagina:"),
            React.createElement(Select, { variant: "standard", disableUnderline: true, size: "small", value: pageSize, onChange: (e) => {
                    onPageSizeChange(Number(e.target.value));
                    onPageChange(0);
                }, sx: {
                    fontSize: "14px",
                    color: "#00244D",
                    "& .MuiSelect-select": {
                        padding: "0px !important",
                        minWidth: "35px !important",
                        fontSize: "14px",
                        paddingY: 0,
                    },
                    "& .MuiSvgIcon-root": { color: "#00244D", right: 0 },
                } }, options.map((option) => (React.createElement(MenuItem, { key: option, value: option, sx: { fontSize: "14px" } }, option)))),
            React.createElement(Typography, { component: "span", sx: {
                    fontSize: "14px",
                    color: "#00244D",
                    whiteSpace: "nowrap",
                    // mr: 1,
                } },
                from,
                "-",
                to,
                " van ",
                count)),
        React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
            React.createElement(IconButton, { "aria-label": "vorige pagina", size: "small", disabled: page <= 0, onClick: () => onPageChange(page - 1), sx: {
                    color: "#00244D",
                    "&.Mui-disabled": {
                        color: (theme) => theme.palette.action.disabled,
                    },
                } },
                React.createElement(ArrowLeft2, { size: 16 })),
            React.createElement(IconButton, { "aria-label": "volgende pagina", size: "small", disabled: page >= pageCount - 1, onClick: () => onPageChange(page + 1), sx: {
                    color: "#00244D",
                    "&.Mui-disabled": {
                        color: (theme) => theme.palette.action.disabled,
                    },
                } },
                React.createElement(ArrowRight2, { size: 16 })))));
};
